import { Component, OnInit, Inject } from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../../../services/global.service';
import Utils from '../../utility';


@Component({
  selector: 'app-risk-rol-advisor-agreement',
  templateUrl: './risk-rol-advisor-agreement.component.html',
  styleUrls: ['./risk-rol-advisor-agreement.component.css']
})

//TODO: Open Account was removed for DAY 1 before it was finished
//Still need to hook up the Download Agreement button - right now it does nothing

export class RiskRolAdvisorAgreementComponent implements OnInit {
  data;
  riskToleranceQuestionnaire: FormGroup;
  riskToleranceMail: FormGroup;
  assetManagementAgreement;
  assetManagementSignedDate;
  adv2DocumentURL;
  displayName;
  hasPartner: boolean = false;
  showOpenAccountSection: boolean = false;
  isNotCandidate: boolean = false;

  constructor(public dialogRef: MatDialogRef<RiskRolAdvisorAgreementComponent>,
    @Inject(MAT_DIALOG_DATA) data, private globalService: GlobalService, private fb: FormBuilder) {
      console.log('RT Agreement passed', data);
      this.data = data;

      this.hasPartner = (this.data.client.clientProfile.Spouses) ? this.data.client.clientProfile.Spouses[0].maritalStatus == 'Married' : false;
      this.displayName = this.data.client.client.FirstName + ' ' + this.data.client.client.LastName 
        + (this.hasPartner ? ' ' + this.data.client.clientProfile.Spouses[0].firstName + ' ' + this.data.client.clientProfile.Spouses[0].lastName : '');
      
        //TODO: do we need this? We do all of this on login?
      this.globalService.getAdvisorData(Number(localStorage.getItem('userId')))
        .subscribe(
          advisor => {
            //this.advisor = advisor;
            console.log('advisor', advisor);
            this.globalService.getOrganizationsData()
                .subscribe(
                  organizations => {
                    console.log('organizations', organizations);
                    //this.OrgRIAFee = org['RIAFee'];
                    //let totalFee = ((this.OrgRIAFee/100) + this.advisoryFee).toFixed(2);
                    this.assetManagementAgreement = organizations[0].AdvisoryAgreement;
                    this.assetManagementAgreement = this.assetManagementAgreement.replace('{{advisor-cost}}', '1.2');//totalFee);
                    this.assetManagementSignedDate = new Date(organizations[0].AdvisoryAgreementChangeDate).toLocaleString();
                    this.adv2DocumentURL = organizations[0].ADVPart2;
                  });
          });
  }

  ngOnInit() {
    this.riskToleranceQuestionnaire = this.fb.group({
      advisorAgreement: [(this.data.obj) ? this.data.obj.advisorAgreement : '', [Validators.required]],
      advisorAgreementSignDate: []
    });

    this.riskToleranceMail = this.fb.group({
      email: ['', [Validators.required]],
      txtEmailAddress: [''],
      accountType: ['', [Validators.required]],
      jointOwnerFirstName: [this.hasPartner ? this.data.client.clientProfile.Spouses[0].firstName : ''],
      jointOwnerLastName: [this.hasPartner ? this.data.client.clientProfile.Spouses[0].lastName : ''],
      jointOwnerEmail: [''],
      aggrement: [''],
      wantsToOpenAnAccount: [false],
      notCandidateToOpenAccount: [false]
    });
  }

  buttonOptions(option){
    this.showOpenAccountSection = false;
    if(option == 'advpart2'){
      window.open(this.adv2DocumentURL, '_blank').focus();
    } else if(option == 'openaccount'){
      this.showOpenAccountSection = true;
    } else if(option =='createaccount') {
        this.riskToleranceMail.controls['wantsToOpenAnAccount'].setValue(true);
        this.close(true);
    } else if(option =='pdf') {
      //download agreement

    } else {
      //previous button click
    }
  }

  close(update): void {
    if (this.riskToleranceQuestionnaire.value.toleranceOfRisk == '1') {
      this.isNotCandidate = true;
      this.riskToleranceMail.controls['notCandidateToOpenAccount'].setValue(true);
    }

    const combinedFormValues = {
        ...this.riskToleranceQuestionnaire.value,
        ...this.riskToleranceMail.value
      };

    if(update){            
      this.dialogRef.close(combinedFormValues);
    } else {
      if(this.riskToleranceQuestionnaire.value.advisorAgreement){
        this.dialogRef.close(combinedFormValues);
      } else {
        this.dialogRef.close();
      }
    }
  }

  adjustAgreementSignedTime() {
    if(this.riskToleranceQuestionnaire.value.advisorAgreement){
      this.assetManagementSignedDate = new Date().toLocaleString();
      this.riskToleranceQuestionnaire.controls['advisorAgreementSignDate'].setValue(this.assetManagementSignedDate);
    }   
  }

  changeDocumentDestination(){
    if(this.riskToleranceMail.value.email == 1){
      this.riskToleranceMail.get("txtEmailAddress").setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]);
    } else {
      this.riskToleranceMail.get("txtEmailAddress").clearValidators();
    }

    this.riskToleranceMail.get("txtEmailAddress").updateValueAndValidity();
  }

  changeAccountType(){
    if(this.riskToleranceMail.value.accountType == '2'){
      this.riskToleranceMail.get("jointOwnerFirstName").setValidators([Validators.required]);      
      this.riskToleranceMail.get("jointOwnerLastName").setValidators([Validators.required]);
      this.riskToleranceMail.get("jointOwnerEmail").setValidators([Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]);
      if(!this.hasPartner){
        this.riskToleranceMail.get("aggrement").setValidators([Validators.required]);      
      }
    } else {
      this.riskToleranceMail.get("jointOwnerFirstName").clearValidators();      
      this.riskToleranceMail.get("jointOwnerLastName").clearValidators();
      this.riskToleranceMail.get("jointOwnerEmail").clearValidators();
      if(!this.hasPartner){
        this.riskToleranceMail.get("aggrement").clearValidators();    
      }
    }
    
    this.riskToleranceMail.get("jointOwnerFirstName").updateValueAndValidity();
    this.riskToleranceMail.get("jointOwnerLastName").updateValueAndValidity();
    this.riskToleranceMail.get("jointOwnerEmail").updateValueAndValidity();
    this.riskToleranceMail.get("aggrement").updateValueAndValidity();
  }

  /* checkRiskTolerance(section) {   
    if (this.riskToleranceQuestionnaire.value.toleranceOfRisk == '1') {
      this.isNotCandidate = true;
    } else {
      this.isNotCandidate = false;
      //this.riskTolernaceSection = 'riskToleranceAggrement';      
      
      // update the user
      //this.saveClientV2(this.clientModelV2, false, true, true);
    }      
  } */
}
